/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleNote } from '../../models/article-note';
import { KeyType } from '../../models/key-type';
import { VirtualArticleNoteResponse } from '../../models/virtual-article-note-response';

export interface AddBundleGroupVirtualArticleNote$Params {
  organizationSiteKey: KeyType;
  groupKey: string;
  virtualArticleKey: string;
      body: ArticleNote
}

export function addBundleGroupVirtualArticleNote(http: HttpClient, rootUrl: string, params: AddBundleGroupVirtualArticleNote$Params, context?: HttpContext): Observable<StrictHttpResponse<VirtualArticleNoteResponse>> {
  const rb = new RequestBuilder(rootUrl, addBundleGroupVirtualArticleNote.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('groupKey', params.groupKey, {});
    rb.path('virtualArticleKey', params.virtualArticleKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VirtualArticleNoteResponse>;
    })
  );
}

addBundleGroupVirtualArticleNote.PATH = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/virtual-articles/{virtualArticleKey}/notes';
